import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  // Start from 23:27:35
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 27,
    seconds: 35
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-6 text-center max-w-2xl mx-auto mb-12" data-id="element-75">
      <div className="flex items-center justify-center gap-2 text-red-500 font-bold mb-4" data-id="element-76">
        <Clock className="w-5 h-5" data-id="element-77" />
        <span className="uppercase tracking-wider text-sm" data-id="element-78">
          Precio de lanzamiento — Cierra en:
        </span>
      </div>

      <div className="flex justify-center items-baseline gap-2 text-4xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-79">
        <div className="w-20" data-id="element-80">
          {format(timeLeft.hours)}
          <span className="text-sm font-sans text-gray-400 block mt-1" data-id="element-81">hs</span>
        </div>
        <span className="text-red-500 pb-6" data-id="element-82">:</span>
        <div className="w-20" data-id="element-83">
          {format(timeLeft.minutes)}
          <span className="text-sm font-sans text-gray-400 block mt-1" data-id="element-84">
            min
          </span>
        </div>
        <span className="text-red-500 pb-6" data-id="element-85">:</span>
        <div className="w-20" data-id="element-86">
          {format(timeLeft.seconds)}
          <span className="text-sm font-sans text-gray-400 block mt-1" data-id="element-87">
            seg
          </span>
        </div>
      </div>

      <p className="text-sm font-medium text-gray-300 mb-6" data-id="element-88">
        ⚠️ Después sube $8.000 ARS. No vuelve.
      </p>

      <div className="space-y-2" data-id="element-89">
        <div className="flex justify-between text-sm font-bold text-red-500" data-id="element-90">
          <span data-id="element-91">🔴 Cupos al precio de lanzamiento — Quedan pocos</span>
          <span data-id="element-92">68%</span>
        </div>
        <div className="w-full bg-white/10 rounded-full h-2.5" data-id="element-93">
          <div className="bg-gold h-2.5 rounded-full" style={{
          width: '68%'
        }} data-id="element-94"></div>
        </div>
        <p className="text-sm text-gray-400" data-id="element-95">68% de los cupos ya tomados</p>
      </div>
    </div>;
}